import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import SelectBox from '../../../../atomic/selectbox/SelectBox'
import { SpecialMarkingList, cuisineList, SizeList } from '../constants'
import { SectionCard } from './SectionCard'
import { EditableField } from './EditableField'
import styles from './styles.module.css'

// Map backend enum values back to human-readable labels for display
const normalizeCategoryLabel = value => {
  const map = {
    main_dish: 'main dish',
    power_side: 'power side',
    drink_dessert_treat: 'drink or dessert or treat',
    main_course: 'main course'
  }
  return map[value] || value
}

export const ClassificationSection = ({
  productCategory, setProductCategory,
  specialMarking, setSpecialMarking,
  cuisineType, setCuisineType,
  size, setSize,
  categoryList,
  editingFields,
  startEdit,
  cancelField,
  trackField
}) => {
  const classKeys = ['product_category', 'special_marking', 'cuisine', 'size']
  const isClassificationEditing = classKeys.some(key => !!editingFields[key])

  const startClassificationEdit = () => {
    classKeys.forEach(key => startEdit(key))
  }

  const cancelClassificationEdit = () => {
    cancelField('product_category', setProductCategory)
    cancelField('special_marking', setSpecialMarking)
    cancelField('cuisine', setCuisineType)
    cancelField('size', setSize)
  }

  return (
    <SectionCard
      title='Classification'
      headerAction={(
        isClassificationEditing ? (
          <button
            onClick={cancelClassificationEdit}
            title='Cancel section editing'
            className={styles.sectionHeaderCancelBtn}
          >
            ✕
          </button>
        ) : (
          <button
            onClick={startClassificationEdit}
            title='Edit Classification'
            className={styles.sectionHeaderEditBtn}
          >
            <EditIcon sx={{ color: '#181436', fontSize: 18 }} />
          </button>
        )
      )}
    >
    <div className={styles.classColumn}>

      <div className={styles.classRow}>
        <div className={styles.classField}>
          <EditableField
            label='Product Category'
            displayValue={normalizeCategoryLabel(productCategory)}
            isEditing={isClassificationEditing}
            showActions={false}
          >
            <SelectBox
              sx={{ width: '100%' }}
              label='Product Category'
              value={(productCategory)}
              onChange={(val) => {
                setProductCategory(val);
                trackField('product_category', val);
              }}
              options={categoryList}
              helperText='Mandatory *'
            />
          </EditableField>
        </div>

        <div className={styles.classField}>
          <EditableField
            label='Special Marking'
            displayValue={specialMarking}
            isEditing={isClassificationEditing}
            showActions={false}
          >
            <SelectBox
              sx={{ width: '100%' }}
              label='Special Marking'
              value={specialMarking}
              onChange={val => { setSpecialMarking(val); trackField('special_marking', val) }}
              options={SpecialMarkingList}
              helperText='Mandatory *'
            />
          </EditableField>
        </div>
      </div>

      <div className={styles.classRow}>
        <div className={styles.classField}>
          <EditableField
            label='Cuisine'
            displayValue={cuisineType}
            isEditing={isClassificationEditing}
            showActions={false}
          >
            <SelectBox
              sx={{ width: '100%' }}
              label='Cuisine'
              value={cuisineType}
              onChange={val => { setCuisineType(val); trackField('cuisine', val) }}
              options={cuisineList}
              helperText='Mandatory *'
            />
          </EditableField>
        </div>

        <div className={styles.classField}>
          <EditableField
            label='Size'
            displayValue={size}
            isEditing={isClassificationEditing}
            showActions={false}
          >
            <SelectBox
              sx={{ width: '100%' }}
              label='Size'
              value={size}
              onChange={val => { setSize(val); trackField('size', val) }}
              options={SizeList}
            />
          </EditableField>
        </div>
      </div>

    </div>
  </SectionCard>
  )
}
